import React from 'react';
import Slider from 'react-slick/lib';

class ProductManagementFeatures extends React.Component {
  render() {
    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4500,
    };

    // Array of text for the different pages. The path key contains an array of paths for the
    // pages which can include regex. The regex is matched against the entire string (using /^
    // and $/) and trailing slashes are automatically removed
    const pages = [
      {
        paths: [
          '/signup/product',
          '/signup/product/pending-email',
          '/users/.*',
        ],
        tag: 'Prospect Path + Software Path',
        title: 'Manage all your profiles in one tool',
        body: 'Create an account to update your product info on Software Path and many more comparison sites',
      },
      {
        paths: [
          '/signup/product/teams',
        ],
        tag: 'Teams',
        title: 'Join or create a space for your team',
        body: 'Create a team for your company, product team or territory',
      },
      {
        paths: [
          '/signup/product/teams/\\d+',
        ],
        tag: 'Products',
        title: 'Choose products to add to your account',
        body: 'Select existing products or add new ones to manage them across multiple comparison sites',
      },
    ];

    const currentPath = window.location.pathname;
    const currentPage = pages
      .filter(page =>
        page.paths.filter(path => RegExp(`^${path}/?$`).test(currentPath)).length > 0)
      .shift();

    return (
      currentPage !== undefined &&
        <div>
          <Slider {...settings}>
            <div className="l-login__gallery-slide">
              <div
                className="l-login__gallery-flair flair flair--primary-inverse flair--transparent">
                {currentPage.tag}
              </div>
              <h3 className="l-login__gallery-title t-login-gallery-title">
                {currentPage.title}
              </h3>
              <h4 className="l-login__gallery-subtitle t-login-gallery-subtitle">
                {currentPage.body}
              </h4>
            </div>
          </Slider>
        </div>
    );
  }
}

export default ProductManagementFeatures;
